var app = angular.module("leonardo");

var AttachmentListDialog = function($scope, $state, $window, AttachmentService) {
  $scope.attachmentService = AttachmentService;
  $scope.attachments = $scope.ngDialogData.attachments;
  $scope.position = $scope.ngDialogData.index ? $scope.ngDialogData.index : 0;

  angular.forEach($scope.attachments, function(attachment){
    if (attachment.document_file) {
      attachment.file = attachment.document_file.signed_view_url;
    }
    else if (attachment.link) {
      attachment.file = attachment.link;
    }
  });

  $scope.next = function() {
    if ($scope.position + 1 === $scope.attachments.length) {
      return;
    }
    $scope.position++;
  };
  $scope.prev = function() {
    if ($scope.position === 0) {
      return;
    }
    $scope.position--;
  };

  $scope.goToAttachment = function(index) {
    if ($scope.attachments[index].document_file) {
      // Use signed_view_url for secure inline viewing
      $window.open($scope.attachments[index].document_file.signed_view_url || $scope.attachments[index].document_file.secure_share_url);
    }
    else if ($scope.attachments[index].link) {
      $window.open($scope.attachments[index].link);
    }
    else {
      // Use signed_view_url for secure inline viewing
      $window.open($scope.attachments[index].signed_view_url || $scope.attachments[index].file);
    }
  }
};

app.controller('AttachmentListDialog', ['$scope', '$state', '$window', 'AttachmentService', AttachmentListDialog]);
